/* eslint-disable camelcase */
// JAR Dashboard Data Configuration and Metadata Provider
import {
  JARActualData,
  JARFacilityFunctionality,
  JARHealthWorkersTraining,
} from './jarActualData';

export const JARPillars = [
  {
    id: 'maternal_child_health',
    name: 'Maternal & Child Health',
    indicators: [
      {
        id: 'maternal_mortality_rate', name: 'Maternal Mortality Rate', unit: 'per 100,000 live births', format: 'number',
      },
      {
        id: 'under_five_mortality_rate', name: 'Under Five (5) Mortality Rate', unit: 'per 1,000 live births', format: 'number',
      },
      {
        id: 'infant_mortality_rate', name: 'Infant Mortality Rate', unit: 'per 1,000 live births', format: 'number',
      },
      {
        id: 'contraceptive_prevalence_rate', name: 'Contraceptive Prevalence Rate', unit: '%', format: 'percentage',
      },
      {
        id: 'antenatal_care_coverage', name: 'Antenatal Care Coverage (4 Visits)', unit: '%', format: 'percentage',
      },
      {
        id: 'skilled_birth_attendance', name: 'Skilled Birth Attendance', unit: '%', format: 'percentage',
      },
      {
        id: 'postnatal_care_coverage', name: 'Postnatal Care Coverage', unit: '%', format: 'percentage',
      },
    ],
  },
  {
    id: 'immunization',
    name: 'Immunization',
    indicators: [
      {
        id: 'zero_dose_children', name: 'Zero Dose Burden', unit: '%', format: 'percentage',
      },
      {
        id: 'penta_3_coverage', name: 'Penta 3 Coverage', unit: '%', format: 'percentage',
      },
      {
        id: 'full_immunization_rate', name: 'Fully Immunized Children', unit: '%', format: 'percentage',
      },
    ],
  },
  {
    id: 'hiv_malaria_control',
    name: 'HIV and Malaria Control',
    indicators: [
      {
        id: 'hiv_infants_negative', name: 'PMTCT (Final Status of HIV Exposed Infants)', unit: '%', format: 'percentage',
      },
      {
        id: 'act_fever_under_5', name: 'Malaria Control (Children Under 5 Who Received ACT)', unit: '%', format: 'percentage',
      },
    ],
  },
  {
    id: 'facility_functionality',
    name: 'Facility Functionality',
    indicators: [
      {
        id: 'phc_functionality', name: 'Health Facility Functionality Analysis', unit: '%', format: 'percentage',
      },
      {
        id: 'health_workers_training', name: 'HRH & Community Health Workforce Training', unit: '%', format: 'percentage',
      },
    ],
  },
];

export const JARStates = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno',
  'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo',
  'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa',
  'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
];

// Highcharts-friendly coordinates matching typical color values
export const JARDatasources = {
  maternal_mortality_rate: {
    primary: { name: 'DHIS2', desc: 'Routine health facility reporting data' },
    secondary: { name: 'MPDSR', desc: 'Maternal Perinatal and Child Death Response audit data' },
  },
  under_five_mortality_rate: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  infant_mortality_rate: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  antenatal_care_coverage: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  contraceptive_prevalence_rate: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  postnatal_care_coverage: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  skilled_birth_attendance: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  penta_3_coverage: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  full_immunization_rate: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  zero_dose_children: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  hiv_infants_negative: {
    primary: { name: 'NACA', desc: 'National Agency for the Control of AIDS' },
    secondary: { name: 'NACA', desc: 'National Agency for the Control of AIDS' },
  },
  act_fever_under_5: {
    primary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
    secondary: { name: 'NDHS', desc: 'National Demographic and Health Survey' },
  },
  phc_functionality: {
    primary: { name: 'PHDA', desc: 'Primary Health Care Development Agency' },
    secondary: { name: 'PHDA', desc: 'Primary Health Care Development Agency' },
  },
  health_workers_training: {
    primary: { name: 'NHMIS', desc: 'National Health Management Information System' },
    secondary: { name: 'NHMIS', desc: 'National Health Management Information System' },
  },
  default: {
    primary: { name: 'DHIS2', desc: 'Routine national registry data' },
    secondary: { name: 'MICS/NDHS Survey', desc: 'National household survey estimate' },
  },
};

// Commentary Text configurations based on figma designs
export const JARCommentaries = {
  maternal_mortality_rate: {
    2025: "In 2025, Nigeria's Maternal mortality rates remained high at 443 and 498 (per 100,000 live births), according to DHIS2 and MPDSR respectively. A deeper look at the state values showed that Northern states had more mothers dying from childbirth than their southern counterparts.\n\nHowever, it is noteworthy that the difference in values from both sources is very wide. This points at serious data quality issues.",
    2024: "In 2024, Nigeria's Maternal mortality rates were 435 and 488 (per 100,000 live births) according to DHIS2 and MPDSR respectively. Significant discrepancies persist between administrative facility data and audit reports, highlighting the urgent need for harmonized tracking.",
    2023: 'In 2023, maternal death audits (MPDSR) were active in only selected tertiary facilities, leading to an extreme under-reporting discrepancy. DHIS2 reported an national average of 420 deaths per 100,000 live births, while MPDSR coverage was under 10%.',
  },
  under_five_mortality_rate: {
    2025: 'There has been a significant reduction in Under 5 mortality rate nationally when comparing 2018 value, 132 to 110 in 2023.\nState level data showed that nothern states have higher rates of under 5 mortality than southern states.\nJigawa (161), Kano (159) and Kebbi (159) have the highest values for Under 5 mortality.\nSource: NDHS',
    2024: 'There has been a significant reduction in Under 5 mortality rate nationally when comparing 2018 value, 132 to 110 in 2023.\nState level data showed that nothern states have higher rates of under 5 mortality than southern states.\nJigawa (161), Kano (159) and Kebbi (159) have the highest values for Under 5 mortality.\nSource: NDHS',
    2023: 'There has been a significant reduction in Under 5 mortality rate nationally when comparing 2018 value, 132 to 110 in 2023.\nState level data showed that nothern states have higher rates of under 5 mortality than southern states.\nJigawa (161), Kano (159) and Kebbi (159) have the highest values for Under 5 mortality.\nSource: NDHS',
  },
  infant_mortality_rate: {
    2025: 'In the same vein, the infant mortality rate in the country continued it\'s downward trend. The value for 2023 was 63 deaths per 1000 live births. This is a slight decrease from the 67 in 2018 and 69 in 2013.\nSimilar to under five mortality, infant mortality was more pronounced in the nothern states than in the south.\nSource: NDHS',
    2024: 'In the same vein, the infant mortality rate in the country continued it\'s downward trend. The value for 2023 was 63 deaths per 1000 live births. This is a slight decrease from the 67 in 2018 and 69 in 2013.\nSimilar to under five mortality, infant mortality was more pronounced in the nothern states than in the south.\nSource: NDHS',
    2023: 'In the same vein, the infant mortality rate in the country continued it\'s downward trend. The value for 2023 was 63 deaths per 1000 live births. This is a slight decrease from the 67 in 2018 and 69 in 2013.\nSimilar to under five mortality, infant mortality was more pronounced in the nothern states than in the south.\nSource: NDHS',
  },
  default: {
    2025: 'Analysis of these indicators across both sources shows steady incremental improvements nationally, although regional disparities between Northern and Southern states persist. Data quality enhancement efforts are underway to reconcile differences.',
    2024: 'Comparative data highlights consistent gaps in routine reporting versus demographic surveys, which is typical of low-and-middle-income health information systems. Strengthening sub-national capacity remains key.',
    2023: 'Baseline analysis shows significant data variance. Users are advised to triangulate routine DHIS2 rates with representative household survey parameters (NDHS/MICS) for policy planning.',
  },
};

// Color brackets for thematic maps based on indicator type
export const JARLegends = {
  maternal_mortality_rate: [
    {
      from: 0, to: 49, color: '#F6D3C4', label: '0 to 49',
    },
    {
      from: 50, to: 149, color: '#F19A82', label: '50 to 149',
    },
    {
      from: 150, to: 299, color: '#E15A44', label: '150 to 299',
    },
    { from: 300, color: '#7B0F13', label: '> 300' },
  ],
  under_five_mortality_rate: [
    {
      from: 0, to: 49, color: '#F6D3C4', label: '0 to 49',
    },
    {
      from: 50, to: 149, color: '#F19A82', label: '50 to 149',
    },
    {
      from: 150, to: 299, color: '#E15A44', label: '150 to 299',
    },
    { from: 300, color: '#7B0F13', label: '> 300' },
  ],
  mortality_general: [
    {
      from: 0, to: 29, color: '#F6D3C4', label: '0 to 29',
    },
    {
      from: 30, to: 69, color: '#F19A82', label: '30 to 69',
    },
    {
      from: 70, to: 99, color: '#E15A44', label: '70 to 99',
    },
    { from: 100, color: '#7B0F13', label: '> 100' },
  ],
  percentage_coverage: [
    {
      from: 0, to: 39, color: '#ffedd5', label: '0% - 39% (Critical)',
    },
    {
      from: 40, to: 59, color: '#fed7aa', label: '40% - 59% (Low)',
    },
    {
      from: 60, to: 79, color: '#a7f3d0', label: '60% - 79% (Medium)',
    },
    {
      from: 80, to: 100, color: '#059669', label: '80% - 100% (High Target)',
    },
  ],
  zero_dose_children: [
    {
      from: 0, to: 19, color: '#fca5a5', label: '0% - 19% (Low Burden)',
    },
    {
      from: 20, to: 39, color: '#f87171', label: '20% - 39% (Moderate Burden)',
    },
    {
      from: 40, to: 59, color: '#ef4444', label: '40% - 59% (High Burden)',
    },
    {
      from: 60, color: '#b91c1c', label: '> 60% (Critical Burden)',
    },
  ],
};

// Helper function to generate state data programmatically for consistency
export const getJARData = (indicatorId, year) => {
  const result = {
    primary: [],
    secondary: [],
    commentary: JARCommentaries[indicatorId]?.[year] || JARCommentaries.default[year] || JARCommentaries.default[2025],
    legend: JARLegends[indicatorId] || (indicatorId.includes('rate') && !indicatorId.includes('prevalence') ? JARLegends.mortality_general : JARLegends.percentage_coverage),
  };

  // 1. Check if we have exact actual data compiled from Excel sheet 1
  const indActual = JARActualData[indicatorId];
  if (indActual) {
    let selectedYearData = indActual[year] || indActual[String(year)];
    if (!selectedYearData) {
      const availableYears = Object.keys(indActual).map((y) => parseInt(y, 10)).sort((a, b) => b - a);
      if (availableYears.length > 0) {
        selectedYearData = indActual[String(availableYears[0])];
      }
    }

    if (selectedYearData) {
      const datasources = Object.keys(selectedYearData);
      const dsConfig = JARDatasources[indicatorId] || JARDatasources.default;
      const primaryName = dsConfig.primary.name;

      const findKey = (name) => datasources.find((k) => k.toLowerCase().includes(name.toLowerCase()) || name.toLowerCase().includes(k.toLowerCase())) || datasources[0];

      const primaryKey = findKey(primaryName);
      const secondaryKey = datasources.find((k) => k !== primaryKey) || primaryKey;

      const pData = selectedYearData[primaryKey];
      const sData = selectedYearData[secondaryKey];

      if (indicatorId === 'under_five_mortality_rate' || indicatorId === 'infant_mortality_rate') {
        const ndhsTrend = [];
        const targetYears = ['2013', '2018', '2023'];
        targetYears.forEach((y) => {
          const yData = indActual[y];
          if (yData) {
            const ySourceKey = Object.keys(yData).find((k) => k.toLowerCase().includes('ndhs'));
            if (ySourceKey && yData[ySourceKey].national && yData[ySourceKey].national.length > 0) {
              const nig = yData[ySourceKey].national.find((n) => n.state === String(y));
              if (nig) {
                ndhsTrend.push({ state: String(y), value: nig.value });
              } else {
                ndhsTrend.push({ state: String(y), value: yData[ySourceKey].national[0].value });
              }
            }
          }
        });

        const ndhsStates = pData ? pData.states : [];
        const dhis2States = sData ? sData.states : [];

        result.primary = {
          trend: ndhsTrend,
          states: ndhsStates,
        };
        result.secondary = dhis2States;
        return result;
      }

      if (pData && pData.states && pData.states.length > 0) {
        result.primary = pData.states;
      } else if (pData && pData.national && pData.national.length > 0) {
        result.primary = pData.national;
      }

      if (sData && sData.states && sData.states.length > 0) {
        result.secondary = sData.states;
      } else if (sData && sData.national && sData.national.length > 0) {
        result.secondary = sData.national;
      }

      return result;
    }
  }

  // 2. PHC Functionality regional average mapping
  if (indicatorId === 'phc_functionality') {
    const StateToRegion = {
      Benue: 'North Central',
      Kogi: 'North Central',
      Kwara: 'North Central',
      Nasarawa: 'North Central',
      Niger: 'North Central',
      Plateau: 'North Central',
      FCT: 'North Central',
      Adamawa: 'North East',
      Bauchi: 'North East',
      Borno: 'North East',
      Gombe: 'North East',
      Taraba: 'North East',
      Yobe: 'North East',
      Jigawa: 'North West',
      Kaduna: 'North West',
      Kano: 'North West',
      Katsina: 'North West',
      Kebbi: 'North West',
      Sokoto: 'North West',
      Zamfara: 'North West',
      Abia: 'South East',
      Anambra: 'South East',
      Ebonyi: 'South East',
      Enugu: 'South East',
      Imo: 'South East',
      'Akwa Ibom': 'South South',
      Bayelsa: 'South South',
      'Cross River': 'South South',
      Delta: 'South South',
      Edo: 'South South',
      Rivers: 'South South',
      Ekiti: 'South West',
      Lagos: 'South West',
      Ogun: 'South West',
      Ondo: 'South West',
      Osun: 'South West',
      Oyo: 'South West',
    };

    const regionTotals = {};
    const regionFunctional = {};
    const regionPartials = {};

    JARFacilityFunctionality.forEach((item) => {
      const loc = item.location;
      if (item.level.toLowerCase().includes('total')) {
        regionTotals[loc] = (regionTotals[loc] || 0) + item.count;
      } else if (item.level.toLowerCase().includes('functional l1') || item.level.toLowerCase().includes('functional l2')) {
        regionFunctional[loc] = (regionFunctional[loc] || 0) + item.count;
      } else if (item.level.toLowerCase().includes('partial')) {
        regionPartials[loc] = (regionPartials[loc] || 0) + item.count;
      }
    });

    const pStates = [];
    const sStates = [];

    JARStates.forEach((state) => {
      const reg = StateToRegion[state];
      if (reg && regionTotals[reg]) {
        const funcRatio = Math.round((regionFunctional[reg] / regionTotals[reg]) * 100);
        const partRatio = Math.round((regionPartials[reg] / regionTotals[reg]) * 100);
        pStates.push({ state, value: funcRatio });
        sStates.push({ state, value: partRatio });
      } else {
        pStates.push({ state, value: 75 });
        sStates.push({ state, value: 15 });
      }
    });

    result.primary = pStates;
    result.secondary = sStates;
    return result;
  }

  // 2b. Health workers training proportion
  if (indicatorId === 'health_workers_training') {
    const trainStates = [];
    JARStates.forEach((state) => {
      const match = JARHealthWorkersTraining.find((item) => item.state === state);
      trainStates.push({ state, value: match ? Math.round(match.value) : 0 });
    });
    result.primary = trainStates;
    result.secondary = trainStates;
    return result;
  }

  // Fallback programmatic generation
  const isPercentage = !indicatorId.includes('rate') || indicatorId.includes('prevalence');

  JARStates.forEach((state, idx) => {
    const hashVal = (state.charCodeAt(0) + state.charCodeAt(state.length - 1) + idx) % 100;

    let primaryVal = 0;
    let secondaryVal = 0;

    if (isPercentage) {
      primaryVal = 30 + (hashVal % 65);
      secondaryVal = Math.max(10, primaryVal - 10 + (hashVal % 20));

      if (year === 2024) {
        primaryVal = Math.max(10, primaryVal - 3);
        secondaryVal = Math.max(10, secondaryVal - 2);
      } else if (year === 2023) {
        primaryVal = Math.max(10, primaryVal - 6);
        secondaryVal = Math.max(10, secondaryVal - 5);
      }
    } else {
      primaryVal = 40 + (hashVal % 90);
      secondaryVal = Math.max(5, primaryVal - 15 - (hashVal % 20));

      if (year === 2024) {
        primaryVal = Math.round(primaryVal * 1.05);
        secondaryVal = Math.round(secondaryVal * 1.03);
      } else if (year === 2023) {
        primaryVal = Math.round(primaryVal * 1.1);
        secondaryVal = Math.round(secondaryVal * 1.08);
      }
    }

    result.primary.push({ state, value: primaryVal });
    result.secondary.push({ state, value: secondaryVal });
  });

  return result;
};
